import React, { Component } from "react";
import "./style/normalSms.css";
import smsIcon from "../../../assets/c2c_sms.svg";

class NormalSms extends Component {
  render() {
    return (
      <button className="normal_sms_btn">
        <div
          className={`my-3 border normal_sms ${
            this.props.sms && !this.props.isSlot ? "clicked" : ""
          }`}
          onClick={this.props.showForm}
        >
          <img className="p-2" src={smsIcon} alt="" />
          <p style={{ fontSize: "12px", padding: "0px", margin: "0px" }}>
            C2C SMS
          </p>
        </div>
      </button>
    );
  }
}

export default NormalSms;
